/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
	advancedRoadmapsLastVisitedProgramBoardIdResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { PORTFOLIO_PLAN_VIEW } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwarePlanTimelineRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwarePlanTimelineRoute.tsx';
import { PlanTimelineSkeleton } from '@jira/platform__skeletons/src/ui/plan/PlanTimelineSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PlanTimelinePage, { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';
import { planTimelinePageEntryPoint } from './ui/plan-timeline/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';

export const softwarePlanTimelineRouteEntry: Route = createEntry(softwarePlanTimelineRoute, () => ({
	group: 'software',
	entryPoint: () => planTimelinePageEntryPoint,
	// eslint-disable-next-line no-restricted-syntax
	component: PlanTimelinePage,
	skeleton: PlanTimelineSkeleton,
	layout: composeLayouts(globalLayout, planLayout),

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarPlanResources(),
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
		advancedRoadmapsLastVisitedProgramBoardIdResource,
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	navigation: {
		menuId: MenuIdPlans,
	},

	forPaint: [LazyAtlassianNavigation, LazyPlanTimeline],
	supportsPreviewPanel: true,
	meta: {
		capability: expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)
			? PORTFOLIO_PLAN_VIEW
			: undefined,
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
